import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageFallback',
  standalone: true
})
export class ImageFallbackPipe implements PipeTransform {
  private readonly DEFAULT_IMAGE = 'https://mkt-image-front.s3.us-east-1.amazonaws.com/not-found.png';

  transform(imageUrl: string | null | undefined): string {
    
    if (!imageUrl || imageUrl.trim() === '') {
      return this.DEFAULT_IMAGE;
    }
    return imageUrl;
  }
}
